export enum FormFeedbackType {
  BANNER = 'banner',
  INLINE = 'inline'
}

export enum FormFeedbackPosition {
  TOP = 'top',
  BOTTOM = 'bottom'
}
